// * localStorage（长期存储） ：与 sessionStorage 一样，但是浏览器关闭后，数据依然会一直存在

/**
 * ! 保存数据到本地
 * name 命名
 * data 存储数据
 * isTrue  true-同页面可以监听，false-同页面无法监听
*/
window.local_Storage_set = function (name, data, isTrue) {
  if (isTrue) {
    var orignalSetItem = window.localStorage.setItem
    window.localStorage.setItem = function (key, newValue) {
      var setItemEvent = new Event('setItemEvent')
      setItemEvent.newValue = newValue
      setItemEvent.key = key
      window.dispatchEvent(setItemEvent)
      orignalSetItem.apply(this, arguments)
    };
  }

  window.localStorage.setItem(name, data)
}

// ! 从本地存储获取数据
window.local_Storage_get = function (name) {
  var getValue = localStorage.getItem(name)
  return getValue
}

// ! 本地存储中删除某个保存的数据
window.local_Storage_delete = function (name) {
  window.localStorage.removeItem(name)
}

// ! 删除所有保存的数据
window.local_Storage_clear = function () {
  window.localStorage.clear()
}

/**
 * ! 监听
 * callback 回调
 * isTrue  true-监听当前页面，false-监听其他页面
*/
window.local_Storage_listen = function (callback, isTrue) {
  if (isTrue) {
    window.addEventListener('setItemEvent', function (e) {
      // console.log(e);
      // console.log('key', e.key);
      // console.log('oldValue', e.oldValue);
      // console.log('newValue', e.newValue);
      // console.log('url', e.url);

      callback(e)
    })
  } else {
    window.addEventListener('storage', function (e) {
      // console.log('key', e.key);
      // console.log('oldValue', e.oldValue);
      // console.log('newValue', e.newValue);
      // console.log('url', e.url);

      callback(e)
    })
  }
}



// WEBPACK FOOTER //
// ./src/utils/localStorage.js